import type { FunctionComponent } from 'react';

import { InChatClarifyCard } from '~/ui/domain/chat/InChatClarifyCard';

import type { ClarifyOptionsBlock } from '../../data-contract/chat';
import { useChatComposerCallbacks } from '../chat-composer-contexts';
import type { BlockRenderer } from './types';

const ClarifyInputOverride: FunctionComponent<{ readonly block: ClarifyOptionsBlock }> = ({ block }) => {
    const { sendMessage } = useChatComposerCallbacks();
    return (
        <div className="flex justify-start">
            <InChatClarifyCard options={block.options} onSelect={sendMessage} />
        </div>
    );
};

export const clarifyOptionsBlockRenderer: BlockRenderer<ClarifyOptionsBlock> = {
    isAnswered: () => false,
    renderInputOverride: (block) => <ClarifyInputOverride block={block} />,
    type: 'clarify-options',
};
